import React, { useEffect, useState } from 'react';
import { PrimaryButton } from './PrimaryButton';
import { CHECKOUT_URL } from '../../utils/checkout';
import { trackInitiateCheckout } from '../../utils/metaPixel';
export function StickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setVisible(window.scrollY > 640);
        ticking = false;
      });
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-gris-claro bg-white/95 backdrop-blur-sm transition-transform duration-300 lg:hidden ${visible ? 'translate-y-0' : 'translate-y-full'}`} aria-hidden={!visible} data-id="element-293" data-mp="2ixvmgkux7sch">
      <div className="flex items-center justify-between gap-3 px-4 py-3" data-id="element-294" data-mp="2sxmfsj7qw1az">
        <div data-id="element-295" data-mp="o1wf79nikuml">
          <p className="font-heading text-sm font-bold text-marino" data-id="element-296" data-mp="o25v24euhlek">17,99€</p>
          <p className="text-[11px] text-gris-muted" data-id="element-297" data-mp="s37twk4unvg0">Acceso inmediato</p>
        </div>
        <PrimaryButton size="md" href={CHECKOUT_URL} onClick={trackInitiateCheckout} data-id="element-298" data-mp="x0zyadmola13">
          Quiero mi Manual
        </PrimaryButton>
      </div>
    </div>;
}